(function () {
    'use strict';

    angular.module('app', [
        'app.calculator',
        'app.dutyFlush',
        'app.enquiry',
        'app.search'
    ]);
})();
